module.exports = __webpack_public_path__ + "img/target-1.bad1e980.png";